import { render, staticRenderFns } from "./PublishEvents.vue?vue&type=template&id=6f34a690&scoped=true"
import script from "./PublishEvents.vue?vue&type=script&lang=js"
export * from "./PublishEvents.vue?vue&type=script&lang=js"
import style0 from "./PublishEvents.vue?vue&type=style&index=0&id=6f34a690&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f34a690",
  null
  
)

export default component.exports